export default (theme) => ({
  gridItem: {
    padding: [10, 5]
  },
  noGroups: {
    fontSize: '20px',
    width: '100%',
    textAlign: 'center',
    marginTop: 60,
  },
});
